
        
    const runtime = require("../../../node_modules/simple-nunjucks-loader/lib/cjs/runtime.js");
    
    const __nunjucks_module_dependencies__ = {};
    
    __nunjucks_module_dependencies__.templates = {};
    __nunjucks_module_dependencies__.globals = {};
    __nunjucks_module_dependencies__.extensions = {};
    __nunjucks_module_dependencies__.filters = {};
    __nunjucks_module_dependencies__.assets = {};
    
    
    
    
    
    
        
            __nunjucks_module_dependencies__.templates["templates/ai-control/components/widgets-decision-log.twig.html"] = (function() {
                function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
output += "  ";
frame = frame.push();
var t_3 = runtime.contextOrFrameLookup(context, frame, "decisionLogEntries");
if(t_3) {t_3 = runtime.fromIterator(t_3);
var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("entry", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n    <div class=\"decision-log-element\" data-equipment=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"equipment"), env.opts.autoescape);
output += "\" data-equipment-value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"equipment_value"), env.opts.autoescape);
output += "\" data-duration=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"duration"), env.opts.autoescape);
output += "\">\n      <div class=\"status\">\n        <div class=\"i18n fading-i18n\">\n          <span class=\"fr\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"label")),"fr"), env.opts.autoescape);
output += "</span>\n          <span class=\"en\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"label")),"en"), env.opts.autoescape);
output += "</span>\n        </div>\n      </div>\n      <div class=\"comment\">\n        <div class=\"i18n fading-i18n\">\n          <span class=\"fr\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"value")),"fr"), env.opts.autoescape);
output += "</span>\n          <span class=\"en\">";
output += runtime.suppressValue(runtime.memberLookup((runtime.memberLookup((t_4),"value")),"en"), env.opts.autoescape);
output += "</span>\n        </div>\n      </div>\n    </div>\n  ";
;
}
}
frame = frame.pop();
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

            })();
        

        function nunjucksTemplate(ctx = {}) {
            const templateContext = {
                __nunjucks_loader_assets__: __nunjucks_module_dependencies__.assets,
                ...ctx
            };

            var nunjucks = (runtime && runtime.default || runtime)(
                {"dev":false,"jinjaCompat":false,"isAsyncTemplate":false},
                __nunjucks_module_dependencies__
            );

            if (nunjucks.isAsync()) {
                return nunjucks.renderAsync(
                    "templates/ai-control/components/widgets-decision-log.twig.html",
                    templateContext
                );
            }
        
            return nunjucks.render(
                "templates/ai-control/components/widgets-decision-log.twig.html",
                templateContext
            );
        };

        nunjucksTemplate.__nunjucks_precompiled_template__ = __nunjucks_module_dependencies__.templates["templates/ai-control/components/widgets-decision-log.twig.html"];
        nunjucksTemplate.__nunjucks_module_dependencies__ = __nunjucks_module_dependencies__;

        exports = module.exports = nunjucksTemplate;
    